var React = require('react');

function IntroQAo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#353F43","d":"M19.839 141.44c7.81 7.81 20.474 7.81 28.284 0l-28.284-28.284c-7.811 7.81-7.811 20.474 0 28.284z","key":0}),React.createElement("path",{"fill":"#9B5D5D","d":"M48.123 113.156c-7.81-7.81-20.474-7.81-28.284 0l28.284 28.284c7.81-7.81 7.81-20.474 0-28.284z","key":1}),React.createElement("path",{"fill":"#02838B","d":"M40 60.703v20c22.091 0 40-17.909 40-40H60c0 11.046-8.954 20-20 20z","key":2}),React.createElement("path",{"fill":"#272728","d":"M40 20.703c11.046 0 20 8.954 20 20h20c0-22.091-17.909-40-40-40s-40 17.909-40 40h20c0-11.045 8.954-20 20-20z","key":3}),React.createElement("path",{"fill":"#A0CFC6","d":"M20 60.703h20v40H20z","key":4})]);
}

IntroQAo.defaultProps = {"viewBox":"0 0 80 148","width":"80","height":"148"};

module.exports = IntroQAo;

IntroQAo.default = IntroQAo;
